import client from './client';

export const listGames = () => client.get('/game');
export const createGame = (gameData = {}) => {
  // maxPlayers is fixed server-side; this payload carries optional flags only
  const payload = typeof gameData === 'number' ? {} : gameData;
  return client.post('/game/create', payload);
};
export const joinGame = (gameId) => client.post(`/game/${gameId}/join`);
export const addNpcToLobby = (gameId) => client.post(`/game/${gameId}/add-npc`);
export const removeNpcFromLobby = (gameId, seatId) => client.post(`/game/${gameId}/remove-npc/${seatId}`);
export const clearNpcs = (gameId) => client.post(`/game/${gameId}/clear-npcs`);
export const requestSeatNextRound = (gameId) => client.post(`/game/${gameId}/request-seat`);
export const respondWaitlistOffer = (gameId, offerId, accept) =>
  client.post(`/game/${gameId}/waitlist-offers/${offerId}/respond`, { accept: !!accept });
export const leaveGame = (gameId) => client.post(`/game/${gameId}/leave`);
export const bumpPlayerToWaitlist = (gameId, userId) => client.post(`/game/${gameId}/bump/${userId}`);
export const collapseInactiveAndRedeal = (gameId) => client.post(`/game/${gameId}/collapse-inactive-redeal`);
export const proposeCollapseInactiveRedeal = (gameId) => client.post(`/game/${gameId}/collapse-propose`);
export const voteCollapseInactiveRedeal = (gameId, approve = true) => client.post(`/game/${gameId}/collapse-vote`, { approve });
export const updateGamePersistence = (gameId, isPersistent) => client.patch(`/game/${gameId}/persistence`, { isPersistent });
export const updateGameSettings = (gameId, payload) => client.patch(`/game/${gameId}/settings`, payload);
export const startGame = (gameId) => client.post(`/game/${gameId}/start`);
export const getGame = (gameId) => client.get(`/game/${gameId}`);
export const getAllTimeLeaderboard = (limit) => {
  const query = Number.isFinite(limit) ? `?limit=${limit}` : '';
  return client.get(`/game/leaderboard/all-time${query}`);
};
export const getPeriodLeaderboard = ({ period = 'monthly', referenceDate, startDate, endDate, limit, tournamentOnly = true } = {}) => {
  const params = new URLSearchParams();
  params.set('period', period);
  if (referenceDate) params.set('referenceDate', referenceDate);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  if (Number.isFinite(limit)) params.set('limit', `${limit}`);
  params.set('tournamentOnly', tournamentOnly ? 'true' : 'false');
  return client.get(`/game/leaderboard/period?${params.toString()}`);
};
export const getStatsOverview = () => client.get('/game/stats/overview');
export const getStatsBattle = (userA, userB) => {
  const params = new URLSearchParams();
  params.set('userA', userA);
  if (userB) params.set('userB', userB);
  return client.get(`/game/stats/battle?${params.toString()}`);
};
export const getPlayerPointsBreakdown = (userId) => {
  const params = new URLSearchParams();
  params.set('userId', userId);
  return client.get(`/game/stats/player-breakdown?${params.toString()}`);
};
export const getChatMessagesByTarget = ({ scope, roomId, recipientId, limit = 120 } = {}) => {
  const params = new URLSearchParams();
  if (scope) params.set('scope', scope);
  if (roomId) params.set('roomId', roomId);
  if (recipientId) params.set('recipientId', recipientId);
  if (Number.isFinite(limit)) params.set('limit', `${limit}`);
  return client.get(`/game/chat/messages?${params.toString()}`);
};
export const deleteChatMessage = (messageId, { scope, roomId } = {}) => {
  const params = new URLSearchParams();
  if (scope) params.set('scope', scope);
  if (roomId) params.set('roomId', roomId);
  const query = params.toString();
  const encodedMessageId = encodeURIComponent(`${messageId || ''}`);
  return client.delete(`/game/chat/messages/${encodedMessageId}${query ? `?${query}` : ''}`);
};
export const clearChatMessages = ({ scope = 'all', roomId } = {}) => {
  const params = new URLSearchParams();
  if (scope) params.set('scope', scope);
  if (roomId) params.set('roomId', roomId);
  return client.delete(`/game/chat/messages?${params.toString()}`);
};
export const getLoungeChat = (limit = 100) => client.get(`/game/lounge-chat?limit=${limit}`);
export const postLoungeChat = (text, recipientUserId = '') => client.post('/game/lounge-chat', { text, recipientUserId });
